// The menu is rendered again through Shopify's Section Rendering API.
// Submit the visitor's real page URL, never the section-rendering URL.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.apo-language-switch, .apo-market-selector')) return;
  const returnTo = form.querySelector('input[name="return_to"]');
  if (!returnTo) return;
  const current = new URL(window.location.href);
  current.searchParams.delete('section_id');
  current.searchParams.delete('sections');
  returnTo.value = current.pathname + current.search + current.hash;
});
